import { useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { getValueFromInputCheck } from "../../../components/funcForInput";
import { ApiEndpoints, reqPostNew } from "../../../config/apiClient";
import stylesCheckbox from "../../colaborador/styles/colaborador.module.css";
import styles from "./RelatorioDadosStyle.module.css";
import RelatorioDownload from "./RelatorioDownload";

export default function RelatorioDados({ comunicado, relatorio, views }: iProps) {
    const [loading, setLoading] = useState<boolean>(false);

    async function enviarNotificacao() {
        let dados = {
            id_comunicado: comunicado.id_comunicado,
            enviar_nao_visualizado: getValueFromInputCheck("enviar_nao_visualizado") === true ? 1 : 0,
            enviar_todos: getValueFromInputCheck("enviar_todos") === true ? 1 : 0,
            ids_colaboradores: getIdsColaboradores(),
        };
        if (dados.enviar_nao_visualizado === 0 && dados.enviar_todos === 0) {
            toast.warning("Selecione alguma opção de notificação!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            return;
        }
        console.log(dados);
        if (dados.ids_colaboradores.length === 0) {
            toast.warning("Selecione ao menos 1 destinatário!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            return;
        }
        setLoading(true);
        const api = await reqPostNew(ApiEndpoints.comunicadosEnviarNotificacao, dados);
        if (api.status === 200) {
            toast.success("Notificação enviada com sucesso!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
        }
        setLoading(false);
    }

    function getIdsColaboradores(): number[] {
        let ids: number[] = [];
        for (let view of views) {
            if (view.acesso === 1) {
                ids.push(view.id_colaborador);
            }
        }
        return ids;
    }

    return (
        <div>
            <br></br>
            <h2 style={{ fontSize: "1.4em", fontWeight: "bold" }}>Relatório</h2>
            <RelatorioDownload comunicado={comunicado} />
            <br></br>
            <div className={styles.comunicado_relatorios}>
                <div>
                    <p>{relatorio.porcentagem_visualizacao} %</p>
                    <span>Visualizou</span>
                </div>
                <div>
                    <p>{relatorio.qtd_visualizacoes}</p>
                    <span>QTD Visualizações</span>
                </div>
                <div>
                    <p>{relatorio.media_qtd_visualizacoes}</p>
                    <span>Média Visualizações</span>
                </div>
                <div>
                    <p>{relatorio.porcentagem_downloads} %</p>
                    <span>Baixou</span>
                </div>
                <div>
                    <p>{relatorio.qtd_downloads}</p>
                    <span>QTD Downloads</span>
                </div>
            </div>
            <br></br>
            <div className="div-row" style={{ alignContent: "start", alignItems: "start" }}>
                <div className="div-row">
                    {loading && <Spinner style={{ marginRight: "10px" }} />}
                    <Button disabled={loading} onClick={() => enviarNotificacao()} variant="info" style={{ marginRight: "10px" }}>
                        Enviar Notificação
                    </Button>
                </div>
                <div>
                    <Form.Check type="switch" id="enviar_todos" label="Enviar para todos" defaultChecked={false} className={stylesCheckbox.inputCheck} />
                    <Form.Check type="switch" id="enviar_nao_visualizado" label="Enviar para todos (não visualizado)" defaultChecked={false} className={stylesCheckbox.inputCheck} />
                </div>
            </div>
        </div>
    );
}
interface iProps {
    comunicado: any;
    relatorio: any;
    views: any[];
}
